module.exports = __webpack_public_path__ + "images/store_case_study/mottai9-pic1_784065d55a9945bf95a9f9330b4b287b.jpg";